<app-header></app-header>
<div class="content-container">
    @if (loading) {
        <div class="loading-container">
            <p>Loading analysis...</p>
        </div>
    } @else {
        @if (analysis !== undefined) {
            <app-attachments [analysis]="analysis"></app-attachments>
            <app-info-box></app-info-box>
            <app-results [analysis]="analysis"></app-results>
        }
    }
</div>
